export enum ENV {
  DEV = 'dev',
  DAILY = 'daily',
  PRE = 'pre',
  PROD = 'prod',
}

const websiteMap: Record<ENV, string> = {
  [ENV.DEV]: '//dolink-test.intra.xiaojukeji.com',
  [ENV.DAILY]: '//dolink-test.intra.xiaojukeji.com',
  [ENV.PRE]: '//dolink-pre.intra.xiaojukeji.com',
  [ENV.PROD]: '//dolink.xiaojukeji.com',
};

const hostMap: Record<ENV, string> = {
  [ENV.DEV]: '//gw-test.intra.xiaojukeji.com',
  [ENV.DAILY]: '//gw-test.intra.xiaojukeji.com',
  [ENV.PRE]: '//gw-pre.am.xiaojukeji.com',
  [ENV.PROD]: '//gw.am.xiaojukeji.com',
};

const { hostname } = location;

function getEnv() {
  if (process.env.NODE_ENV === 'development') {
    return ENV.DEV;
  } else if (
    /dolink-test\.intra\.xiaojukeji\.com/.test(hostname) ||
    /static-daily\.am\.xiaojukeji\.com/.test(hostname)
  ) {
    return ENV.DAILY;
  } else if (
    /dolink-pre\.intra\.xiaojukeji\.com/.test(hostname) ||
    /static-pre\.am\.xiaojukeji\.com/.test(hostname)
  ) {
    return ENV.PRE;
  } else if (/dolink\.xiaojukeji\.com/.test(hostname)) {
    return ENV.PROD;
  }
}

export const isDev = process.env.NODE_ENV === 'development';
export const env = getEnv();

export const host = hostMap[getEnv()!];
export const website = websiteMap[getEnv()!];
